"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Builder = void 0;
var jquery_1 = __importDefault(require("jquery"));
var file_saver_1 = require("file-saver");
var imageArgsToFilename = function (fileArgs) {
    var qIndex = fileArgs.indexOf('?');
    var file = fileArgs;
    if (qIndex >= 0) {
        file = fileArgs.substring(0, qIndex);
    }
    return file;
};
var setCookie = function (cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
};
var getCookie = function (cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
};
var Builder = /** @class */ (function () {
    function Builder() {
    }
    Builder.prototype.imageTranslation = function (translatedPath, listProducer) {
        this.translateImage_ = function (url, list, lang) {
            var fileArgs = url.substring(url.lastIndexOf('/') + 1);
            var file = imageArgsToFilename(fileArgs);
            if (list.includes(file)) {
                return translatedPath(lang, fileArgs);
            }
            return url;
        };
        this.processImagesList_ = listProducer;
        return this;
    };
    Builder.prototype.linkTranslation = function (translatedPath, listProducer, urlToFilename) {
        this.urlToFilename_ = urlToFilename;
        this.translateAsset_ = function (url, list, lang) {
            if (urlToFilename) {
                var file = urlToFilename(url);
                if (file && list.includes(file)) {
                    return translatedPath(lang, file);
                }
            }
            return url;
        };
        this.processAssetList_ = listProducer;
        return this;
    };
    Builder.prototype.textTranslation = function (dictProducer, tags) {
        this.processDict_ = dictProducer;
        this.tags_ = tags;
        return this;
    };
    Builder.prototype.getLang = function (arg) {
        this.getLang_ = arg;
        return this;
    };
    Builder.prototype.setLang = function (arg) {
        this.setLang_ = arg;
        return this;
    };
    Builder.prototype.useLocalStorage = function (keyName) {
        this.getLang_ = function () { return localStorage.getItem(keyName); };
        this.setLang_ = function (lang) { return localStorage.setItem(keyName, lang); };
        return this;
    };
    Builder.prototype.useCookie = function (keyName) {
        this.getLang_ = function () { return getCookie(keyName); };
        this.setLang_ = function (lang) { return setCookie(keyName, lang, 3650); };
        return this;
    };
    Builder.prototype.sourceLang = function (arg) {
        this.sourceLang_ = arg;
        return this;
    };
    Builder.prototype.langInUrl = function (arg) {
        this.langInUrl_ = arg;
        return this;
    };
    Builder.prototype.tags = function (arg) {
        this.tags_ = arg;
        return this;
    };
    Builder.prototype.textDownload = function () {
        var set = new Set();
        jquery_1["default"](this.tags_).contents()
            .each(function () {
            if (this.nodeType == 3) {
                var data = this['data'];
                if (data) {
                    set.add(data);
                }
            }
        });
        var list = Array.from(set);
        var blob = new Blob([JSON.stringify(list, undefined, 2)], { type: "application/json;charset=utf-8" });
        file_saver_1.saveAs(blob, "texts.json");
    };
    Builder.prototype.imageDownload = function () {
        var set = new Set();
        var addToSet = function (src) {
            if (src) {
                var fileArgs = src.substring(src.lastIndexOf('/') + 1);
                var file = imageArgsToFilename(fileArgs);
                if (file) {
                    set.add(file);
                }
            }
        };
        jquery_1["default"]('img').each(function () {
            jquery_1["default"](this).attr('data-src', function (i, src) {
                addToSet(src);
            });
            jquery_1["default"](this).attr('src', function (i, src) {
                addToSet(src);
            });
        });
        var list = Array.from(set);
        var blob = new Blob([JSON.stringify(list, undefined, 2)], { type: "application/json;charset=utf-8" });
        file_saver_1.saveAs(blob, "images.json");
    };
    Builder.prototype.linkDownload = function () {
        var set = new Set();
        var self = this;
        jquery_1["default"]('a').each(function () {
            jquery_1["default"](this).attr('href', function (i, href) {
                if (href) {
                    var file = self.urlToFilename_(href);
                    if (file) {
                        set.add(file);
                    }
                }
            });
        });
        var list = Array.from(set);
        var blob = new Blob([JSON.stringify(list, undefined, 2)], { type: "application/json;charset=utf-8" });
        file_saver_1.saveAs(blob, "links.json");
    };
    Builder.prototype.init = function () {
        var _this = this;
        jquery_1["default"](function () {
            if (!_this.sourceLang_) {
                console.error("Squarelate: source lang not set");
                return;
            }
            if (!_this.setLang_ || !_this.getLang_) {
                console.error("Squarelate: setLang or getLang not set");
                return;
            }
            var queryDict = {};
            location.search.substr(1).split("&").forEach(function (item) {
                queryDict[item.split("=")[0]] = item.split("=")[1];
            });
            var lang = _this.sourceLang_;
            var savedLang = _this.getLang_();
            if (queryDict.hasOwnProperty('lang')) {
                lang = queryDict['lang'];
            }
            else if (savedLang) {
                lang = savedLang;
            }
            _this.setLang_(lang);
            if (_this.langInUrl_) {
                history.pushState({}, '', window.location.pathname + "?lang=" + lang);
            }
            if (lang !== _this.sourceLang_) {
                if (_this.processDict_ && _this.tags_) {
                    _this.processDict_(lang, function (data) {
                        jquery_1["default"](_this.tags_).contents()
                            .each(function () {
                            if (this.nodeType == 3 && data.hasOwnProperty(this['data'])) {
                                this['data'] = data[this['data']];
                            }
                        });
                    });
                }
                var self_1 = _this;
                if (_this.processAssetList_ && _this.translateAsset_) {
                    _this.processAssetList_(lang, function (data) {
                        jquery_1["default"]('a').each(function () {
                            jquery_1["default"](this).attr('href', function (i, href) {
                                if (href) {
                                    return self_1.translateAsset_(href, data, lang);
                                }
                            });
                        });
                    });
                }
                if (_this.processImagesList_ && _this.translateImage_) {
                    _this.processImagesList_(lang, function (data) {
                        jquery_1["default"]('img').each(function () {
                            jquery_1["default"](this).attr('data-src', function (i, src) {
                                if (src) {
                                    return self_1.translateImage_(src, data, lang);
                                }
                            });
                            jquery_1["default"](this).attr('src', function (i, src) {
                                if (src) {
                                    return self_1.translateImage_(src, data, lang);
                                }
                            });
                        });
                    });
                }
            }
        });
    };
    return Builder;
}());
exports.Builder = Builder;
//# sourceMappingURL=Builder.js.map